import { ApolloError } from "@apollo/client";

import { SubmissionError } from "../../lens/models";
import { isCommunityDistributionPermissionDenied } from "../../notifications";

interface LensPublicationErrorMessages {
    fallback: string;
    communityDistributionDenied: string;
}

const isCommunityDistributionDeniedError = (error: unknown): boolean =>
    error instanceof ApolloError &&
    error.graphQLErrors.some(({ message }) => isCommunityDistributionPermissionDenied(message));

export const getLensPublicationErrorMessage = (error: unknown, messages: LensPublicationErrorMessages): string => {
    if (error instanceof SubmissionError) {
        return error.message;
    }

    return isCommunityDistributionDeniedError(error) ? messages.communityDistributionDenied : messages.fallback;
};
